export default "__VITE_ASSET__rJAATjAs__"